import { render, staticRenderFns } from "./AbaPoliticaComercial.vue?vue&type=template&id=06543ff8&scoped=true"
import script from "./AbaPoliticaComercial.vue?vue&type=script&lang=js"
export * from "./AbaPoliticaComercial.vue?vue&type=script&lang=js"
import style0 from "./AbaPoliticaComercial.vue?vue&type=style&index=0&id=06543ff8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06543ff8",
  null
  
)

export default component.exports